(function () {
  function normalizeColor(val) {
    return String(val || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/\s+/g, '-');
  }

  async function addToCart(variantId) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      await res.json();

      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));

      const cartTrigger = document.querySelector('.hdt-site-nav_cart a[aria-controls="CartDrawer"]');
      if (cartTrigger) cartTrigger.click();

    } catch (err) {
      console.error(err);
    }
  }

 function updateSaleBadges(root) {
  const colorInputs = root.querySelectorAll('.hdt-color-list-item input[type="radio"]');
  const sizeButtons = root.querySelectorAll('.hdt-size-list-item');

  let activeColorInput = root.querySelector('.hdt-color-list-item input[type="radio"]:checked');
  if (!activeColorInput && colorInputs.length) {
    activeColorInput = colorInputs[0];
    activeColorInput.checked = true;
  }

  const activeColor = normalizeColor(activeColorInput?.value);

  /* ========= COLOR SALE ========= */
  colorInputs.forEach(input => {
    const color = normalizeColor(input.value);
    const label = input.closest('label') || input.nextElementSibling;
    const badge = label?.querySelector('.hdt-sale-badge');
    if (!badge) return;

    const hasSaleInColor = Array.from(sizeButtons).some(btn =>
      btn.classList.contains('visible-size') &&
      normalizeColor(btn.dataset.color) === color &&
      btn.dataset.onSale === 'true'
    );

    badge.toggleAttribute('hidden', !hasSaleInColor);
  });

  /* ========= SIZE SALE (SOLO COLOR ACTIVO) ========= */
  sizeButtons.forEach(btn => {
    const badge = btn.querySelector('.hdt-sale-badge');
    if (!badge) return;

    const btnColor = normalizeColor(btn.dataset.color);
    const isVisible = btn.classList.contains('visible-size');
    const isSale = btn.dataset.onSale === 'true';

    if (isVisible && btnColor === activeColor && isSale) {
      badge.removeAttribute('hidden');
    } else {
      badge.setAttribute('hidden', '');
    }
  });
}

  function applyColorSizeLogic(root) {
    const colorInputs = root.querySelectorAll('.hdt-color-list-item input[type="radio"]');
    const sizeButtons = root.querySelectorAll('.hdt-size-list-item');

    if (!sizeButtons.length) return;

    let activeColor = root.querySelector('.hdt-color-list-item input[type="radio"]:checked');
    if (!activeColor && colorInputs.length) {
      activeColor = colorInputs[0];
      activeColor.checked = true;
    }

    const selectedColor = normalizeColor(activeColor?.value);

    sizeButtons.forEach(btn => {
      const btnColor = normalizeColor(btn.dataset.color);

      if (btnColor === selectedColor) {
        btn.classList.remove('hidden');
        btn.classList.add('visible-size');
      } else {
        btn.classList.add('hidden');
        btn.classList.remove('visible-size');
      }
    });

    updateSaleBadges(root);
  }

  document.addEventListener('change', e => {
    if (!e.target.matches('.hdt-color-list-item input[type="radio"]')) return;
    const root = e.target.closest('.hdt-card-product__wrapper') || document;
    applyColorSizeLogic(root);
  });

  document.addEventListener('click', e => {
    if (!e.target.matches('.hdt-size-list-item')) return;
    if (!e.target.dataset.variantId) return;

    const root = e.target.closest('.hdt-card-product__wrapper') || document;
    root.querySelectorAll('.hdt-size-list-item').forEach(b => b.classList.remove('active'));
    e.target.classList.add('active');

    addToCart(e.target.dataset.variantId);
  });

  function init(root = document) {
    root.querySelectorAll('.hdt-card-product__wrapper').forEach(applyColorSizeLogic);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('turbo:load', init);

})();
